import { useAPIs } from 'src/hooks/useAPIs';
import { useQuery } from 'react-query';
import { QueryKey } from 'src/models/query';
import { aboutUsGqlQuery } from 'src/modules/about-us/graphql/aboutus.query';
import { APIs } from 'src/models/apis';

export const fetchAboutUs = async (apis: APIs) => {
  const directus = await apis.directus();

  return directus.query(aboutUsGqlQuery);
};

export const useAboutUsQuery = () => {
  const apis = useAPIs();

  return useQuery(QueryKey.AboutUs, () => fetchAboutUs(apis));
};
